import React from "react";

function Heading(props) {
  return <div className="title">{props.heading}</div>;
}

export default Heading;
